import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LocationResponse } from '../../constants/types'

interface locationsState {
  selectedLocation: LocationResponse | null
  selectedLocationId: number | null
  selectedLocationsIds: number[]
}

const initialState: locationsState = {
  selectedLocation: null,
  selectedLocationId: null,
  selectedLocationsIds: [],
}

export const locationsSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    setSelectedLocation(state, action: PayloadAction<LocationResponse | null>) {
      state.selectedLocation = action.payload
    },
    setSelectedLocationId(state, action: PayloadAction<number | null>) {
      state.selectedLocationId = action.payload
    },

    addSelectedLocation(state, action: PayloadAction<number>) {
      if (!state.selectedLocationsIds.includes(action.payload)) {
        state.selectedLocationsIds.push(action.payload)
      }
    },
    replaceSelectedLocations(state, action: PayloadAction<number[]>) {
      state.selectedLocationsIds = action.payload
    },
  },
})

export const locationsActions = locationsSlice.actions
export const locationsReducer = locationsSlice.reducer
